
import { DataIndexItem } from '../../../types/interfaces';
import Modal from 'antd/es/modal/Modal';
import { Spin, Tabs, Tooltip, message } from 'antd';
import { ReactComponent as CloseIcon } from "../../../assets/svgs/icons/close-icon.svg";
import ProjectDetails from './ProjectDetails';
import ConversionDetails from './ConversionDetails';
import { DataIndexMenuEditModalContainer } from '../conversionMenu.style';
import { useState } from 'react';
import { InfoCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { buildDataItem, loadDataItem } from '../../tables/dataIndexTable/DataIndexLambdaUtils';

interface DataIndexMenuEditModalProps {
    onCancel: () => void;
    data: DataIndexItem;
    onChanged: (dataId: string, values?: DataIndexItem) => void;
}


const DataIndexMenuEditModal = ({ onCancel, data, onChanged }: DataIndexMenuEditModalProps) => {
    const [dataItem, setDataItem] = useState<DataIndexItem>(data);
    const [dataLoading, setDataLoading] = useState<boolean>(false);
 
    const formattedDetails = (
        <>
            <div className='project_inner_detail_block'>
                <span className='data_label'>Data ID:</span> 
                <span className='data_label_value'>{dataItem.data_id}</span>
            </div>
            <div className='project_inner_detail_block'>
                <span className='data_label'>Owner ID:</span>
                <span className='data_label_value'>{dataItem.owner_id}</span>
            </div>
        </>
      );

    const handleCancel = () => {
        onCancel();
    };

    const tabItems = [
        {
            label: (
                <span className='project-details'>
                Project Details 
                   <Tooltip title={formattedDetails}>
                     <InfoCircleOutlined className='infoIcon' />
                   </Tooltip> 
            </span>
            ),
            key: '1',
            children: (
                <ProjectDetails onCancel={onCancel} data={dataItem} onChanged={onChanged }/>
            ),
        },
        {
            label: (
                <span>
                    Conversion
                </span>
            ),
            key: '2',
            children: (
                <ConversionDetails onCancel={onCancel} data={dataItem} onChanged={onChanged} />
            ),
        },
    ];

    const onReload = async () => { 
        setDataLoading(true);
        loadDataItem(dataItem.data_id, dataItem.owner_id).then(async (res) => {
            const data = buildDataItem(res); 
            setDataItem(data); 
        })
        .catch((err) => {
            console.log(err);
            message.error("Failed to load data");
        })
        .finally(() => {
            setDataLoading(false);
        }); 
    }


    return (
        <Modal
            open
            centered
            width={800}
            mask={false}
            onCancel={handleCancel}
            className="batch_modal create_batch_modal conversation_modal"
            closeIcon={<CloseIcon key="CloseIcon" color='#ffffff' onClick={handleCancel} />}
            footer={null}
            style={{
                backgroundColor: "#36BDBE",
                width: "800px !important", // Adjust the width as per your need
                maxWidth: "100%", // Set maximum width if needed
            }}
        >
            <DataIndexMenuEditModalContainer>
                <div className='table-container'>
                    <div className="custom-tab-container custom_conversation_tab_container">
                    <Spin spinning={dataLoading}>
                        <Tabs defaultActiveKey={data.entwine_build_path === "" ? "2" : "1"}
                            items={tabItems}
                            className="custom-tabs">
                        </Tabs>
                        <div className="tab-icons modal-tab-reload"> 
                             <ReloadOutlined key="reload" title="Reload" onClick={() => onReload()} style={{ color: "#ffffff" }} />        
                         </div>
                    </Spin> 
                    </div>
                </div>
            </DataIndexMenuEditModalContainer>
        </Modal>
    );
}

export default DataIndexMenuEditModal;
